(function () {
  let swiperProductMarkersSplit;
  const initProductMarkers = (section) => {
    if (!section || !section?.classList.contains("product-markers-section")) {
      return;
    }
    const isSplitLayout = section.querySelector(".product-markers-split");
    if (isSplitLayout) {
      initSplitLayout(section);
      return;
    }
    const allMarkers = section.querySelectorAll(".product-markers__item");
    const mobileContainer = section.querySelector(
      ".product-markers-for-mobile"
    );
    if (!mobileContainer) return;
    const allMobileCards = mobileContainer.querySelectorAll(
      ".product-markers__item-inner"
    );
    const renameColorSwatchInputIds = () => {
      section
        .querySelectorAll(".product-markers__item-inner")
        .forEach((el, index) => {
          const allSwatchInputs = el.querySelectorAll("input[type='radio']");
          const allSwatchLabels = el.querySelectorAll("label.color-swatch");
          allSwatchInputs.forEach((input) => {
            const oldId = input.id;
            const oldName = input.name;
            input.id = `${oldId}-card${index}`;
            input.name = `${oldName}-card${index}`;
          });
          allSwatchLabels.forEach((label) => {
            const oldFor = label.htmlFor;
            label.htmlFor = `${oldFor}-card${index}`;
          });
        });
    };
    renameColorSwatchInputIds();
    const calcNewCoord = (marker) => {
      const card = marker.querySelector(".product-markers__item-inner");
      const markerRect = marker.getBoundingClientRect();
      if (!card) return;
      card.style.removeProperty("left");
      card.style.removeProperty("right");
      const cardRect = card.getBoundingClientRect();
      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;
      if (cardRect.right > screenWidth) {
        let newRight = markerRect.right - cardRect.right;
        if (card.classList.contains("product-markers__item-inner--to-right")) {
          newRight = -1 * (screenWidth - markerRect.right - 20);
        }
        card.style.left = "auto";
        card.style.right = `${newRight}px`;
      } else if (cardRect.left < 0) {
        let newLeft = markerRect.left - cardRect.left;
        if (card.classList.contains("product-markers__item-inner--to-left")) {
          newLeft = -1 * markerRect.left;
        }
        card.style.right = "auto";
        card.style.left = `${newLeft}px`;
      } else {
      }
    };
    const onSelectMarker = (marker) => {
      const index = marker.dataset.index;
      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;
      allMarkers.forEach((marker) => {
        marker.classList.remove("mobile-initial-active");
      });
      if (marker.classList.contains("active")) {
        return;
      }
      allMarkers.forEach((marker) => {
        marker.classList.remove("active");
      });
      marker.classList.add("active");
      if (screenWidth >= 990) {
        calcNewCoord(marker);
        return;
      }
      allMobileCards.forEach((card) => {
        card.classList.remove("active");
        if (card.dataset.index == index) {
          card.classList.add("active");
        }
      });
    };
    allMarkers.forEach((marker) => {
      calcNewCoord(marker);
      marker.addEventListener("click", (event) => {
        if (event.target.closest(".js-color-swatches")) return;
        onSelectMarker(marker);
      });
      marker.addEventListener("mouseover", () => {
        if (marker.classList.contains("active")) {
          return;
        }
        const screenWidth =
          document.documentElement.clientWidth || window.innerWidth;
        if (screenWidth >= 990) {
          calcNewCoord(marker);
        }
      });
      marker.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          onSelectMarker(marker);
        }
      });
    });
    document.addEventListener("click", (event) => {
      const screenWidth =
        document.documentElement.clientWidth || window.innerWidth;
      if (screenWidth < 990) return;
      const parentClicked = event.target.closest(".product-markers__item");
      allMarkers.forEach((marker) => {
        if (
          parentClicked != marker &&
          !event.target.closest(".js-color-swatches")
        ) {
          marker.classList.remove("active");
        }
      });
    });
  };
  const updateSliderPosition = (section) => {
    const parentContainer = section.querySelector(
      ".product-markers-split-content"
    );
    const imagesContainer = section.querySelector(".product-markers__markers");
    const firstSlideImage = section.querySelector(
      ".card-small-image-link-wrapper"
    );
    if (!firstSlideImage || !parentContainer || !imagesContainer) return;
    parentContainer.style.paddingTop = "";
    parentContainer.style.paddingBottom = "";
    imagesContainer.style.margin = "auto 0";
    if (window.innerWidth < 990) {
      return;
    }
    const parentRect = parentContainer.getBoundingClientRect();
    const imagesContainerRect = imagesContainer.getBoundingClientRect();
    const imageRect = firstSlideImage.getBoundingClientRect();
    const currentOffset = imageRect.top - parentRect.top;
    const targetOffset = parentRect.bottom - imageRect.bottom;
    const extraPadding = targetOffset - currentOffset;
    if (imagesContainerRect.height < parentRect.height) {
      const offset =
        currentOffset + imageRect.height / 2 - imagesContainerRect.height / 2;
      if (offset < 0) {
        imagesContainer.style.margin = "0";
        parentContainer.style.paddingTop = `${-offset}px`;
        return;
      }
      imagesContainer.style.margin = `${offset}px 0 0 0`;
      return;
    }
    if (extraPadding < 0) {
      parentContainer.style.paddingBottom = `${-extraPadding}px`;
      return;
    }
    parentContainer.style.paddingTop = `${extraPadding}px`;
  };
  const updateNavPosition = (section) => {
    const nav = section.querySelector(".product-markers-split-nav");
    if (!nav) return;
    const firstSlide = section.querySelector(
      ".product-markers-split-slider-slide__product"
    );
    if (!firstSlide) return;
    const imgWrapper = firstSlide.querySelector(
      ".card-small-image-link-wrapper"
    );
    if (!imgWrapper) return;
    const swiperEl = section.querySelector(".product-markers-split-slider");
    const swiperRect = swiperEl.getBoundingClientRect();
    const imgRect = imgWrapper.getBoundingClientRect();
    const offsetTop = imgRect.top - swiperRect.top;
    const centerY = offsetTop + imgRect.height / 2;
    nav.style.top = `${centerY}px`;
  };
  const initSplitSlider = (section) => {
    if (!!swiperProductMarkersSplit) {
      return;
    }
    const swiperEl = section.querySelector(".product-markers-split-slider");
    if (!swiperEl) return;
    const prevBtn = section.querySelector(
      ".product-markers-split-nav-button--prev"
    );
    const nextBtn = section.querySelector(
      ".product-markers-split-nav-button--next"
    );
    const markers = section.querySelectorAll(".product-markers__item");
    const slides = section.querySelectorAll(
      ".product-markers-split-slider-slide"
    );
    const markersMap = new Map(
      Array.from(markers, (el) => [el.dataset.markerId, el])
    );
    const slidesMap = new Map(
      Array.from(slides, (el, index) => [el.dataset.markerId, index])
    );
    const sliderOptions = {
      slidesPerView: 1,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      spaceBetween: 16,
      speed: 500,
      allowTouchMove: true,
      loop: true,
      mousewheel: {
        forceToAxis: true,
      },
      preventClicks: true,
      watchOverflow: true,
      navigation:
        nextBtn && prevBtn
          ? {
              nextEl: nextBtn,
              prevEl: prevBtn,
              disabledClass: "swiper-button-disabled",
            }
          : false,
      on: {
        slideChange: function (e) {
          const currentSlide = e.slides[e.activeIndex];
          const markerId = currentSlide.dataset.markerId;
          if (markerId) {
            markers.forEach((marker) => {
              marker.classList.remove("active");
              marker.classList.remove("mobile-initial-active");
            });
            const correspondingMarker = markersMap.get(markerId);
            if (correspondingMarker) {
              correspondingMarker.classList.add("active");
            }
          }
        },
        afterInit: function () {
          updateSliderPosition(section);
          updateNavPosition(section);
        },
      },
    };
    swiperProductMarkersSplit = new Swiper(swiperEl, sliderOptions);
    const nav = section.querySelector(".product-markers-split-nav");
    if (nav) {
      nav.classList.add("product-markers-split-nav--visible");
    }
    markers.forEach((marker) => {
      const markerId = marker.dataset.markerId;
      marker.addEventListener("click", () => {
        if (swiperProductMarkersSplit && markerId) {
          const slideIndex = slidesMap.get(markerId);
          if (slideIndex !== undefined) {
            swiperProductMarkersSplit.slideToLoop(slideIndex);
          }
        }
      });
      marker.addEventListener("mouseover", () => {
        if (window.innerWidth >= 990 && swiperProductMarkersSplit && markerId) {
          const slideIndex = slidesMap.get(markerId);
          if (slideIndex !== undefined) {
            swiperProductMarkersSplit.slideToLoop(slideIndex);
          }
        }
      });
      marker.addEventListener("focus", () => {
        if (swiperProductMarkersSplit && markerId) {
          const slideIndex = slidesMap.get(markerId);
          if (slideIndex !== undefined) {
            swiperProductMarkersSplit.slideToLoop(slideIndex);
          }
        }
      });
    });
  };
  const initSplitLayout = (section) => {
    let sectionWidth = section.getBoundingClientRect().width;
    initSplitSlider(section);
    const sectionResizeObserver = new ResizeObserver((entries) => {
      const [entry] = entries;
      if (entry.contentRect.width != sectionWidth) {
        updateSliderPosition(section);
        updateNavPosition(section);
        sectionWidth = entry.contentRect.width;
      }
    });
    sectionResizeObserver.observe(section);
  };
  const initHeadingAnimation = (section) => {
    if (!section || !section?.classList.contains("product-markers-section")) {
      return;
    }
    const enableAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    if (!enableAnimation) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const section = entry.target;
            section.classList.add("anim-active");
            observer.unobserve(section);
          }
        });
      },
      {
        threshold: 0,
        rootMargin: "0px 0px -25% 0px",
      }
    );
    observer.observe(section);
  };
  initProductMarkers(document.currentScript.parentElement);
  initHeadingAnimation(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", function (event) {
    initProductMarkers(event.target);
    initHeadingAnimation(event.target);
  });
})();
